// Vendors
import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

const SearchField = ({ currentRefinement, refine }) => (
  <span className="form__field form__input-group-search u--display-block">
    <input
      type="search"
      placeholder="Search by Keyword"
      className="form__input form__input-search"
      value={currentRefinement}
      onChange={(event) => refine(event.currentTarget.value)}
    />
    <i className="fa fa-search form__input-search-icon"></i>
  </span>
);

export default connectSearchBox(SearchField);
